export * from './compare.component';
